<script setup>
import {computed} from "vue";

const model = defineModel()

const props = defineProps({
    value: [String, Number]
})
const notSelected = computed(() => {
    return !model.value.includes(props.value);
})

const check = () => {
    //console.log(model.value)
    if (notSelected.value) {
        model.value.push(props.value)
    } else {
        model.value.splice(model.value.indexOf(props.value), 1);
    }
}
</script>

<template>
    <div class="border flex items-center justify-center shadow-sm rounded cursor-pointer " @click="check" role="checkbox"
         :aria-checked="notSelected" style="width: 19px; height: 19px" :class="{
    'bg-blue-500 hover:bg-blue-600 hover:border-blue-600 border-blue-500 text-white': notSelected,
    'hover:border-gray-400 border-gray-300': !notSelected
}">
        <i v-if="notSelected" class="pi pi-check" style="font-size: .8rem"></i>
    </div>
</template>

<style scoped lang="scss">

</style>
